import script from "./TEditorElement.vue?vue&type=script&lang=js"
export * from "./TEditorElement.vue?vue&type=script&lang=js"

import "./TEditorElement.vue?vue&type=style&index=0&id=267e54d2&lang=scss"

const __exports__ = script;

export default __exports__